import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import NewsMediaCard from '../components/cards/NewsMediaCard';
import { useStore } from '../store/context';

const NewsPage = observer((): JSX.Element => {
  const { newsStore } = useStore();

  const roleNames = [
    'Architekt',
    'Fachunternehmer',
    'Heimwerker',
    'Handelspartner',
  ];

  return (
    <>
      <Container sx={{ marginLeft: '20%', width: '100%' }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <div>
            <Grid container spacing={2}>
              {newsStore?.rolesArray.map((elem, index) => (
                <Grid item xs={6} key={elem.roleName}>
                  <Typography style={{ textAlign: 'center' }} variant="h4">
                    {roleNames[index]}
                  </Typography>
                  <hr style={{ maxWidth: '70%' }} />
                  <NewsMediaCard key={elem.roleName} newsElement={elem} />
                </Grid>
              ))}
            </Grid>
          </div>
        </Box>
      </Container>
    </>
  );
});

export default NewsPage;
